export const inspectTable = [
  {
    content: [
      '1. 안전보건관리책임자 업무수행에 필요한 권한과 예산을 부여받고 적합한 용도로 집행',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '2. 서울특별시교육청의 산재예방계획 수립',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '3. 안전보건관리규정의 작성 및 변경',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '4. 근로자 안전보건교육 실시',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '5. 작업환경의 점검 및 개선',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '6. 근로자의 건강진단 등 건강관리',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '7. 산업재해 원인조사 및 재발 방지대책 수립',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '8. 산업재해에 관한 통계의 기록 및 유지관리',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '9. 안전장치 및 보호구 구입 시 적격품 여부 확인',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '10. 위험성평가의 실시',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
  {
    content: [
      '11. 안전보건규칙에서 정하는 근로자의 위험 또는 건강장해의 방지',
      {
        type: 'textarea',
        value: '',
      }
    ],
    isChecked: '',
  },
];
